export default __webpack_public_path__ + "static/media/heart.b582b011.png";